import { useBlogPostsQuery } from 'hooks/useBlogPostsQuery'
import { useUrl } from 'hooks/useUrl'
import { useRouter } from 'next/router'
import { ComponentType, Fragment } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { BlogPagination } from './BlogPagination'
import { BlogPostCard } from './BlogPostCard'
import { FeaturedPost } from './FeaturedPost'

export const BlogPosts: ComponentType = () => {
  const router = useRouter()
  const { query } = useUrl()

  const { loading, data } = useBlogPostsQuery({
    variables: {
      query: {
        limit: 5,
        page: query.page,
        filter: router.query.tagSlug ? `tag:${router.query.tagSlug}` : undefined,
      },
    },
  })

  if (data) {
    const { posts, meta } = data.blogPosts
    const [post, ...postList] = posts

    return (
      <Fragment>
        {post && <FeaturedPost post={post} />}
        <Container className="pt-60">
          <Row>
            {postList.map((post: any) => (
              <Col key={post.id} lg={4} className="py-40">
                <BlogPostCard post={post} />
              </Col>
            ))}
          </Row>
        </Container>
        {meta.pagination.pages > 1 && <BlogPagination pagination={meta.pagination} loading={loading} />}
      </Fragment>
    )
  }

  return null
}
